import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

/**
 * Richer form of the dialog's input. A bare string is still accepted so the existing
 * callers that pass a presigned URL directly keep working unchanged.
 */
export interface PdfDialogData {
  /** Presigned URL. Absent when there is nothing to display. */
  pdf?: string;
  /** Empty-state copy, shown when there is no pdf. */
  message?: string;
  /** Optional line beside the header, e.g. "Batch file · 2 pages". */
  subtitle?: string;
}

@Component({
  selector: 'app-pdf-dialog',
  standalone: false,
  templateUrl: './pdf-dialog.component.html',
  styleUrls: ['./pdf-dialog.component.css']
})
export class PdfDialogComponent {

  constructor(public dialogRef: MatDialogRef<PdfDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string | PdfDialogData) {
  }

  /** The URL to preview, or null when the dialog is showing an empty state. */
  get pdfUrl(): string | null {
    const url = typeof this.data === 'string' ? this.data : this.data?.pdf;
    // The fragment is part of the first URL the viewer loads: changing the viewer's URL after it
    // loads adds a history entry, so browser back would step inside the PDF instead of closing it.
    return url ? `${url}#view=fitH` : null;
  }

  get hasPdf(): boolean {
    return this.pdfUrl !== null;
  }

  get subtitle(): string | null {
    return typeof this.data === 'string' ? null : this.data?.subtitle ?? null;
  }

  get message(): string {
    const message = typeof this.data === 'string' ? null : this.data?.message;
    return message ?? 'There is nothing to display for this document.';
  }
}
